var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-settings"},[_c('global-title-with-filter-bar',{attrs:{"title":_vm.$route.meta.title,"hidedate":true,"buttons":_vm.buttons}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }